export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes";
export const API_KEY = "92e7e297-e250-4e01-a5d3-93a81d579b24";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MIN_SERVINGS = 1;
export const MAX_SERVINGS = 20;
export const MODAL_CLOSE_SEC = 2.5;
